import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../../shared/context/auth-context';
// import Avatar from '../../shared/components/UIElements/avatar';
import Like from '../../shared/components/FormElements/like';
import Comment from '../../shared/components/FormElements/comment';

import './Posts.css';
import CourseModal from '../../shared/components/UIElements/courseModal';
import Share from '../../shared/components/FormElements/share';

// import ShareModal from '../../shared/components/UIElements/shareModal';


const Posts = () => {

  const { user } = useContext(AuthContext);

  const [postData, setPostData] = useState([]);

    const [open, setOpen] = useState(false);

  // FETCH ALL POSTS
  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/posts');
        const responseData = await response.json();
        if (!response.ok){
          throw new Error('Failed to fetch posts')
        }
        setPostData(responseData.post);
        // console.log('this post id: ', responseData.post.map(p => p._id))
      } catch (err) {
        console.log(err.message)
      }
    }
    fetchPost()
  }, []);


    const handleOpen = (postId) => setOpen(postId);
    const handleClose = () => setOpen(false)
 
  

  // Time Format
  const timeHandler = (createdAt) => {
    const now = new Date();
    const postTime = new Date(createdAt);
    const diffInSeconds = Math.floor((now - postTime) / 1000);

    const secInMinute = 60;
    const secInHour = 3600;
    const secInDay = 86400;
    const secInWeek = secInDay * 7;
    const secInMonth = secInDay * 30;

    if (diffInSeconds < secInMinute) {
      return `${diffInSeconds}s`;
    } else if (diffInSeconds < secInHour) {
      const minutes = Math.floor(diffInSeconds / secInMinute);
      return `${minutes}m`;
    } else if (diffInSeconds < secInDay) {
      const hours = Math.floor(diffInSeconds / secInHour);
      return `${hours}h`;
    } else if (diffInSeconds < secInWeek) {
      const days = Math.floor(diffInSeconds / secInDay);
      return `${days}d`;
    } else if (diffInSeconds < secInMonth) {
      const weeks = Math.floor(diffInSeconds / secInWeek);
      return `${weeks}w`;
    } else {
      // After 1 month → display like "12, May"
      return postTime.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short'
      });
    }
  }

 

  return (
    <main className='post-face-container'>
     
      <div className='post-controller'> 


        <div className='post-interface-container'>

          <div className='post-interface-name'>
            <Link to='/user' >
              <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt='pic' title={user.name}/>
            </Link>
          </div>
          
          <div className='post-interface-main-controller'>
            <Link to='/createPost' style={{ display: 'flex', width:'100%',  textDecoration: 'none'}} >
              <div className='post-interface-controller'>
                Сэтгэдэл Бичих...
              </div>
            </Link>
          </div>
          
        </div>

        <div className='post-post-container'>
            <h1>Posts</h1>
            {/* <Link to='/user'>User Profile</Link> */}
            {postData.map((post, index) => (
              <div key={index} className='post-post-controller'>

                <div className='post_creator_name'>
                  <img src={`${process.env.REACT_APP_ASSET_URL}/${post.creator.image}`} alt='p' title={post.creator.name} style={{margin: '0px 10px 10px 0px', borderRadius: '5px'}}/>
                  <div>
                    <div>{post.creator.name}</div>
                    <div style={{fontSize: '0.7rem'}}>
                      {timeHandler(post.createdAt)}
                    </div>
                  </div>
          
                </div>
                
                <h3>{post.title}</h3>
                <div className='post-image-container'>

                  {post.video ? (
                    <div className='post-image-controller'>
                    
                      <video controls width="100%" className='userPost-video'>
                        <source 
                          src={`${process.env.REACT_APP_ASSET_URL}/${post.video}`}   
                          type={`video/${post.video.split('.').pop()}`}
                          
                        />                           
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : post.image ? (
                    <div className='post-image-controller'>
                      <img src={`${process.env.REACT_APP_ASSET_URL}/${post.image}`} alt='pic'/>
                    </div> 
                  ) : null }
                  
                  
                </div>
                <p>{post.post}</p>

                <footer className='post-footer'>
                  {/* Like */}
                  
                  <div className='post-footer-like'>      
                    <Like 
                      postId={post._id} 
                      initialLikes={post.likes} 
                      isLikedByUser={post.likes?.includes(user?.id)}
                      className='footer-like'
                    />
                  </div>

                  {/* Comment */}
                  <div className='post-footer-comment'>
                    <button 
                      className='footer-comment' 
                      onClick={() => handleOpen(post._id)}> 
                      {post.comments.length === 0
                        ? "Comment" 
                        : post.comments.length === 1 
                          ? "1 Comment"
                          : `${post.comments.length} Comments`
                      }
                    </button>
                  
                    {open === post._id && (<CourseModal show={open} onCancel={handleClose}>
                      <Comment 
                        postId={post.id}
                      />
                      </CourseModal>
                    )}
                  </div>
                
                  {/* Share */}
                  <div className='post-footer-share'>                
                    <Share
                      postId={post._id}                       
                    />
                  </div>
             
                </footer>
              </div>
            ))}
        </div>
      </div>     
    </main>      
  )
}
export default Posts;